@if (isInitialized) {
    <div class="state-jurisdiction-list ws-flex-container-vertical ws-flex-auto">
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title page-title">
                    State and Jurisdiction Command Center
                    <ag-grid-row-count [gridApi]="gridApi"
                                       [gridTracker]="gridTracker"
                                       [gridOptions]="gridOptions"></ag-grid-row-count>
                </h4>
                <div class="ws-section__header__actions">
                    <div class="ws-section__header__actions__item">
                        <div><small class="me-2">View:</small></div>
                        <div dropdown container="body" placement="bottom right">
                            <button id="button-basic"
                                    dropdownToggle
                                    type="button"
                                    class="ace-btn btn-link btn-sm dropdown-toggle"
                                    aria-controls="dropdown-basic"
                                    [disabled]="editing">
                                {{ selectedGridSourceOption.name }}
                                <span class="caret"></span>
                            </button>
                            <ul id="dropdown-basic"
                                *dropdownMenu
                                class="dropdown-menu dropdown-menu-end"
                                role="menu"
                                aria-labelledby="button-basic">
                                @for (gso of gridSourceOptions; track gso) {
                                    <li role="menuitem">
                                        <a class="pointer" (click)="setSelectedGridSourceOption(gso)">{{ gso.name }}</a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div class="ws-section__header__actions__item">
                        <div class="action-button-wrapper"
                             helpTooltip
                             [helpContentId]="refreshHelpContentId"
                             position="bottom">
                            <button type="button"
                                    class="ace-btn btn-sm btn-secondary has-icon"
                                    [disabled]="(!canGetRows) || editing"
                                    (click)="refresh()">
                                <i class="fa fa-refresh"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <command-view-controls></command-view-controls>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)"
                            [gridId]="gridId"
                            [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                            [exportOptions]="exportOptions"
                            (bulkUpdate)="bulkUpdate()"
                            [defaultSizeToFit]="false"
                            [defaultSizeToContent]="true">
        </ws-ag-grid-angular>
    </div>
}
